import React, { createContext, useContext } from 'react';

/**
 * backgroundMode controls the page-level background strategy:
 *   'gradient' — CSS animated gradient (default, best performance)
 *   'image'    — static background image passed via backgroundImage prop
 *   'none'     — no managed background (consumer handles it)
 */
export const BACKGROUND_MODES = {
  GRADIENT: 'gradient',
  IMAGE: 'image',
  NONE: 'none',
};

const LiquidGlassContext = createContext();

export const useLiquidGlassContext = () => {
  const context = useContext(LiquidGlassContext);
  return context || { parentVariant: null, depth: 0, backgroundMode: BACKGROUND_MODES.GRADIENT };
};

export const LiquidGlassProvider = ({
  children,
  variant,
  depth = 0,
  backgroundMode = BACKGROUND_MODES.GRADIENT,
}) => {
  return (
    <LiquidGlassContext.Provider value={{ parentVariant: variant, depth, backgroundMode }}>
      {children}
    </LiquidGlassContext.Provider>
  );
};

// Helper function to determine inverted variant
export const getInvertedVariant = (parentVariant, currentVariant = 'auto') => {
  // If current variant is explicitly set to light or dark, respect it
  if (currentVariant === 'light' || currentVariant === 'dark') {
    return currentVariant;
  }
  
  // If parent is dark, child should be light
  if (parentVariant === 'dark') {
    return 'light';
  }
  
  // If parent is light, child should be dark
  if (parentVariant === 'light') {
    return 'dark';
  }
  
  // If parent is auto or no parent, use auto
  return 'auto';
};
